module.exports = __webpack_public_path__ + "static/media/undo-tutorial-1.92c58dc6.gif";